import { type CAPITAL_PARTNER_NETWORK_CONTENT } from '../content';
import {
  CardStack,
  ContentContainer,
  Section,
  SectionEyebrow,
  SectionIntro,
  SectionParagraph,
  SectionTitle,
  SplitGrid,
  SurfaceCard,
  SurfaceEyebrow,
  SurfaceText,
  SurfaceTitle,
} from '../styles';

type MarketProblemCopy = (typeof CAPITAL_PARTNER_NETWORK_CONTENT)['marketProblem'];

type MarketProblemSectionProps = {
  copy: MarketProblemCopy;
};

export default function MarketProblemSection({
  copy,
}: MarketProblemSectionProps) {
  return (
    <Section>
      <ContentContainer>
        <SplitGrid>
          <SectionIntro>
            <SectionEyebrow>{copy.eyebrow}</SectionEyebrow>
            <SectionTitle>{copy.title}</SectionTitle>
          </SectionIntro>
          <CardStack>
            <SurfaceCard>
              <SectionParagraph>{copy.paragraphs[0]}</SectionParagraph>
              <SurfaceText>{copy.paragraphs[1]}</SurfaceText>
            </SurfaceCard>
            <SurfaceCard>
              <SurfaceEyebrow>The inefficiency</SurfaceEyebrow>
              <SurfaceTitle>More choice does not automatically create more conviction.</SurfaceTitle>
              <SurfaceText>
                The gap is between polished availability and verified readiness.
              </SurfaceText>
            </SurfaceCard>
          </CardStack>
        </SplitGrid>
      </ContentContainer>
    </Section>
  );
}
